import React from 'react';
import PropTypes from 'prop-types';

import Header from '../../blocks/Header';
import WebsiteBanner from '../../blocks/WebsiteBanner';
import ColumnText from '../../blocks/ColumnText';
import Usps from '../../blocks/Usps';
import ContactForm from '../../blocks/ContactForm';
import Footer from '../../blocks/Footer';
import scrollToTopOrHash from '../../utils/helpers/scrollToTopOrHash';
import { sendPageView } from '../../utils/helpers/ga';

import start_Image from './assets/startpage.png';
import production_Image from './assets/webproduction.png';
//import contactImage from './assets/contact.png';
import hosting_Image from './assets/hostingpage.png';

class Website extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      scrollToTopOrHash();
      window.document.title = 'Prisvärd 1:st Line Support - ScandGate AB';
      sendPageView(this.props.location.pathname);
    }
  }

  render() {
    return (
      <div id="container">
        <Header />

        <WebsiteBanner
          headline="1:st Line Support hos oss?"
          image1={start_Image}
          image2={production_Image}
//          image2={contactImage}
          image3={hosting_Image}
        >
        <h3>
          Hur går det till?
        </h3>

          <p>
              Scandgate skapar upp en supportavdelning som tar emot inkommande supportärenden från
              era företagskunder. Denna kundtjänst har öppet mellan 9:00-16:00 måndag till fredag.
              Kommunikationskanaler blir via telefon samt e-post. Telefonlinjen är kopplad till ett
              eget dedikerat 010-nummer i vår telefonväxel. Numret påvisar att det är era företagskunder
              som ringer. Parallellt med telefonväxeln skapar vi upp en supportmailadress och ett
              supportformulär som är kopplat till vår Helpdesk . När vi svarar på inkommande mailtrafik
              så använder vi en till er företagskopplad mailadress, så att alla mailsvar verkar komma
              från en supportavdelning inifrån företaget. Vid all ärendehantering svarar vi med företagsnamnet
              och ger sken av intern hantering. Lättare ärenden som inloggningsuppgifter, instruktioner,
              allmänna frågeställningar, synpunkter samt teknisk felanmälan sköter vi om, medan mer tekniskt
              komplicerade frågeställningar och åtgärder sänds vidare till er utvecklingsavdelning (2:nd Line
              Support) via en Jira-integration i vår Helpdeskplattform.
          </p>
        </WebsiteBanner>

        <ColumnText headline="Vad kan vi?" dark>
          <p>
            En del av vår personal är utbildade webbutvecklare och andra är serveradministratörer med
            lång erfarenhet inom området. Sammantaget behärskar vi HTML, CSS, PHP, Javascript, Wordpress,
            DNS-/mailhantering, serverdrift m.m.  Vi har god vana av såväl telefon- som mailsupport och
            att kunna arbeta strukturerat och metodiskt samt veta vilka arbetsverktyg man ska använda i
            sin verksamhet anser vi vara en förutsättning för att lyckas vid uppbyggnad av en ny
            supportavdelning.
          </p>
          <p>
            Vår ambition är alltid att kunna upprätta en supportfunktion som täcker våra kunders behov och
            hjälper ert företag att nå sina mål. För att nå målen anser vi att det är viktigt att vi på
            ScandGate till fullo förstår ert företags existerande och kommande behov.
          </p>
        </ColumnText>

        <ContactForm
          darker
          headline="Kontakta ScandGate"
          content={<p>Vi svarar inom 24 timmar</p>}
          hostingPackages={{
          xxs: 'Upp till 10 användare',
            xs: 'Mellan 11 - 25 användare',
            s: 'Mellan 26 - 50 användare',
            l: 'Mellan 51 - 100 användare',
            xl: 'Mellan 101 - 250 användare',
            xxl: 'Över 250 användare',
            }}
          ctaText="Kontakta oss"
        />

        <Footer />
      </div>
    );
  }
}

Website.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Website;



// WEBPACK FOOTER //
// ./pages/Website/index.js